import "./GridText.css";

const GridText = () => {
  return (
    <>
      <div className="grid-text top">
        <h3>Community managers</h3>
        <h3>Social media managers</h3>
        <h3>Sales Managers</h3>
        <h3>Graphic Designers</h3>
      </div>
      <div className="grid-text bottom">
        <h3>Growth Marketers</h3>
        <h3>Digital Marketers</h3>
        <h3>Customer Success Manager</h3>
        <h3>Content Writers</h3>
      </div>
    </>
  );
};

export default GridText;
